import store from '@/store/store.js'
import VueCookie from 'vue-cookie'
// import Vue from 'vue'
import router from '../routes/router'

export function dashboardPermissionRedirect () {
  try {
    let roles = VueCookie.get('roles')
    let defaultRoute = VueCookie.get('default_route')
    if (roles) {
      if (roles.includes('ROLE_SUPER_USER') ||
        roles.includes('ROLE_SERVICEMAN') ||
        roles.includes('ROLE_EXTERNAL_SERVICEMAN') ||
        roles.includes('ROLE_DISPATCHER') ||
        roles.includes('ROLE_OWNER') ||
        roles.includes('ROLE_SALES_REPRESENTATIVE')
      ) {
        return '/admin/timetable/dashboard'
      } else if (roles.includes('ROLE_CLIENT') || roles.includes('ROLE_WHOLESALER')) {
        return `/admin/dashboard/client`
      } else if (defaultRoute) {
        return defaultRoute
      } else return '/login'
    }
  } catch (e) {
    return '/login'
  }
}

export function checkPagePermission (type, view) {
  let canView = checkPermission(type, view)
  if (canView === true) {
    return true
  } else {
    router.push('/admin')
    console.error('forbidden')
    return false
  }
}

export function getUserRoles () {
  // get userdata
  let user = {}
  if (VueCookie.get('name') != null || VueCookie.get('surname') != null) {
    user.id = VueCookie.get('user_id')
    user.id_userdata = VueCookie.get('user_data_id')
    user.name = VueCookie.get('name')
    user.surname = VueCookie.get('surname')
    user.roles = VueCookie.get('roles')
    user.user_employer = VueCookie.get('user_employer')
    user.id_client_type = VueCookie.get('id_client_type')
    user.default_disable_roles_filtering = VueCookie.get('default_disable_roles_filtering')
  } else {
    user.id = store.state.user.id
    user.id_userdata = store.state.user.id_userdata
    user.name = store.state.user.name
    user.surname = store.state.user.surname
    user.roles = store.state.user.roles
    user.user_employer = store.state.user.user_employer
    user.id_client_type = store.state.user.id_client_type
    user.default_disable_roles_filtering = store.state.user.default_disable_roles_filtering
  }
  return user
}

export function checkPermission (type, view = '', component = '') {
  let user = {}
  if (VueCookie.get('name') != null || VueCookie.get('surname') != null) {
    user.name = VueCookie.get('name')
    user.surname = VueCookie.get('surname')
    user.roles = VueCookie.get('roles')
  } else {
    user.name = store.state.user.name
    user.surname = store.state.user.surname
    user.roles = store.state.user.roles
  }
  let acl = store.getters['configuration/acl']
  if (type) {
    let aclType = acl[type]
    if (!aclType) { return false }
    if (view) {
      let aclView = aclType['views'][view]
      if (!aclView) { return false }
      if (component) {
        let aclComponent = aclView['components'][component]
        if (!aclComponent) { return false }
        return JSON.parse(user.roles).some(r => (aclComponent['roles'].indexOf(r) >= 0))
      } else {
        return JSON.parse(user.roles).some(r => (aclView['roles'].indexOf(r) >= 0))
      }
    } else {
      // return aclType['roles'].includes(user.roles)
      return JSON.parse(user.roles).some(r => (aclType['roles'].indexOf(r) >= 0))
    }
  } else {
    return false
  }
}
